import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { PresetGroupsContext } from '../context';
import PropTypes from 'prop-types';
import { EditButton } from './editButton';
import { DeleteButton } from './deleteButton';
import messages from '../messages';
import style from '../style.module.less';

const ActionsColumn = ({ id: presetGroupId }) => {
  const { setNeedsReload, needsReload } = useContext(PresetGroupsContext);

  return (
    <>
      <span className={style['edit-button']}>
        <EditButton presetGroupId={presetGroupId} />
      </span>
      <DeleteButton needsReload={needsReload} presetGroupId={presetGroupId} setNeedsReload={setNeedsReload} />
    </>
  );
};

ActionsColumn.propTypes = {
  id: PropTypes.number.isRequired,
};

export const actions = {
  getMessageDescriptor: messages.actionsColumn,
  name: <FormattedMessage {...messages.actionsColumn} />,
  id: 'actions',
  isSortable: false,
  render: ActionsColumn,
};
